// extracted by mini-css-extract-plugin
module.exports = {"carousel":"DraggableMarquee_carousel__Qezah","container":"DraggableMarquee_container__pl_3v","dragging":"DraggableMarquee_dragging__5LExs"};